import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import {
    useMultiResourceSingleParentedResourceAdapterActions,
} from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import { IdSchema } from '../../../resource-base/baseSchemas';
import {
    defaultParentedPersistableResource,
    ParentedPersistableResourceSchema,
} from '../../../resource-base/persistableResourceTypes';

export enum ProjectUserGroupRoleAssignmentPropertyValidation {
    PROJECT_USER_GROUP = 'PROJECT_USER_GROUP',
    PROJECT_USER_ROLES = 'PROJECT_USER_ROLES',
}

export const ProjectUserGroupRoleAssignmentResourceSchema = ParentedPersistableResourceSchema.extend({
    projectUserGroup: IdSchema,
    projectUserRoles: IdSchema.array(),
    resourceType: z
        .literal(ResourceType.PROJECT_USER_GROUP_ROLE_ASSIGNMENT)
        .default(ResourceType.PROJECT_USER_GROUP_ROLE_ASSIGNMENT),
});

export const ProjectUserGroupRoleAssignmentMutationResourceSchema = getMutationSchema(
    ProjectUserGroupRoleAssignmentResourceSchema
);

export type ProjectUserGroupRoleAssignmentResource = z.infer<typeof ProjectUserGroupRoleAssignmentResourceSchema>;

export const defaultProjectUserGroupRoleAssignmentResource: ProjectUserGroupRoleAssignmentResource = {
    ...defaultParentedPersistableResource,
    resourceType: ResourceType.PROJECT_USER_GROUP_ROLE_ASSIGNMENT,
    projectUserGroup: '',
    projectUserRoles: [],
};

export function useProjectUserGroupRoleAssignmentActions() {
    return useMultiResourceSingleParentedResourceAdapterActions(
        'project-user-group-role-assignment',
        ResourceType.PROJECT_USER_GROUP_ROLE_ASSIGNMENT,
        ProjectUserGroupRoleAssignmentResourceSchema
    );
}
